import { render } from "./Scoruri.vue?vue&type=template&id=4570cdd3&scoped=true"
import script from "./Scoruri.vue?vue&type=script&lang=js"
export * from "./Scoruri.vue?vue&type=script&lang=js"

import "./Scoruri.vue?vue&type=style&index=0&id=4570cdd3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4570cdd3"]])

export default __exports__